export const urlHasComponent = (component: string): boolean => window.location.pathname.split('/').includes(component)
